<template>
  <span :style="[imageSize]">
    <v-img style="width:100%;height:100%;" src="/res/icon/iot/camera.png" />
  </span>
</template>

<script>
export default {
  name: 'DeviceIconImage',
  components: {},
  props: {
    size: {
      type: Number,
      default: 72
    },
    width: {
      type: Number,
      default: 72
    },
    height: {
      type: Number,
      default: 72
    }
  },
  data() {
    return {
      defaultSize: 72
    }
  },
  computed: {
    imageSize() {
      var that = this
      var ret = {
        'width': that.width + 'px',
        'height': that.height + 'px'
      }
      if (that.size !== that.defaultSize) {
        ret = {
          'width': that.size + 'px',
          'height': that.size + 'px'
        }
      }
      return ret
    },
    lineHeight() {
      var that = this
      var ret = {
        'line-height': that.height + 'px'
      }
      if (that.size !== that.defaultSize) {
        ret = {
          'line-height': that.size + 'px'
        }
      }
      return ret
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {
  }
}
</script>

<style scoped>
.offline_img{
    filter: opacity(70%) grayscale(100%) !important;
   -webkit-filter: opacity(70%) grayscale(100%) !important;
}
.offline_img /deep/ .v-image__image{
    filter: opacity(70%) grayscale(100%) !important;
   -webkit-filter: opacity(70%) grayscale(100%) !important;
 }
</style>
